import { render, staticRenderFns } from "./AddSurveys.vue?vue&type=template&id=44cb2078&scoped=true&"
import script from "./AddSurveys.vue?vue&type=script&lang=js&"
export * from "./AddSurveys.vue?vue&type=script&lang=js&"
import style0 from "./AddSurveys.vue?vue&type=style&index=0&id=44cb2078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb2078",
  null
  
)

export default component.exports